import Image from "next/image";
// import Link from "next/link";
import React from "react";

const Hero: React.FC = () => {
  return (
    <div id="main-hero" className="relative h-screen w-full">
      <Image src="/photos/Accueil/PhotoDrazHome.webp" alt="DraZ en LAN" className="object-cover opacity-10 lg:opacity-90" placeholder="blur" blurDataURL={"/photos/Accueil/PhotoDrazHome.webp"} layout="fill" quality={70} priority />
      <div className="absolute top-1/2 right-1/2 max-w-2xl -translate-y-1/2 translate-x-1/2 transform text-center lg:right-2/4 lg:ml-8 lg:-translate-y-1/2 lg:-translate-x-0 lg:text-left">
        <h1 className={`text-4xl font-bold uppercase tracking-widest text-whiteAccent lg:text-5xl`}>DeathroW esport</h1>
        <p className="tracking-relaxed text-sm text-whiteAccent/70">Club esportif français révélateur de talents, présent depuis 2001 dans le paysage des compétitions électroniques, formateur et innovant.</p>
      </div>
    </div>
  );
};

export default Hero;
